import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-project-authentification',
  templateUrl: './project-authentification.component.html',
  styleUrls: ['./project-authentification.component.scss']
})
export class ProjectAuthentificationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
